import angular from 'angular';

import createModule from './createEdgeStackView';

export default angular.module('shbdeployer.edge.stacks', [createModule]).name;
